export default () => 
URL.createObjectURL(new Blob([
    `
    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

    function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
    
    self.addEventListener('message',
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(function* (event) {
        const result = yield fetch(event.data.url);
        const data = yield result.json();
        const mapperObject = event.data.mapper;
        const dataMap = data.map(item => {
          let mapper = {};
    
          for (map in mapperObject) {
            mapper[map] = item[mapperObject[map]];
          }
    
          return mapper;
        });
        self.postMessage({
          result: dataMap
        });
      });
    
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
` 
], {type: 'application/javascript'}));